import React from "react";
import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";
import { usePageMeta } from "../lib/usePageMeta";

export default function NotFound() {
  usePageMeta("404 — Tool Not Found | Utiliverse", "The page you're looking for doesn't exist.");
  return (
    <div className="bp-grid min-h-[70vh] flex items-center justify-center px-5">
      <div className="text-center">
        <h1 className="font-heading font-black text-8xl sm:text-9xl tracking-tighter text-signal">404</h1>
        <p className="font-mono uppercase tracking-[0.25em] text-ink/60 mt-2">Tool not found</p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="inline-flex items-center gap-2 mt-8 bg-signal text-paper font-bold uppercase tracking-wide border-2 border-ink px-6 py-4 shadow-brutal hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-brutalSm transition-all"
        >
          <HomeIcon className="w-5 h-5" /> Back to home
        </Link>
      </div>
    </div>
  );
}
